import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import server from 'server/serverController2';
import { formatDate } from 'utils/utils.js';

import LoadingAnimation from 'images/lottiefile/yellow_loading_animation.json';

import CurrentActiveUserNote from 'components/containers/campaign/achievement/CurrentActiveUserNote';
import MyAchievementRate from 'components/presenters/campaign/achievement/MyAchievementRate';
import AchievementRateList from 'components/presenters/campaign/achievement/AchievementRateList';
import LottieLodder from 'components/containers/common/LottieLoader';

export default function CampaignAchievementLayout({campaignInfo, campaignNo, isMember}) {
    const userInfo = useSelector((state) => {
        return state['userInfo'];
    }) 

    const [taskCount, setTaskCount] = useState(null);
    const [completeRate, setCompleteRate] = useState(0);

    //membersRanking
    const [memberAchievementRateList, setMemberAchievementRateList] = useState([]);

    const [isTaskCountLoading, setIsTaskCountLoading] = useState(false);
    const [isTaskCountEnd, setIsTaskCountEnd] = useState(false);
    const [isMembersAchievementRateLoading, setIsMembersAchievementRateLoading] = useState(false);
    const [isMembersAchievementRateEnd, setIsMembersAchievementRateEnd] = useState(false);
    const [topNoteText, setTopNoteText] = useState('');

    const history = useHistory();
    
    const getTaskCount = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                setIsTaskCountEnd(true);
                return;
            }
            const jsonData = res['data'];
            const completedRate = Math.floor((jsonData['result_count'] / jsonData['task_count']) * 100);
            
            setTaskCount(jsonData);
            setCompleteRate(completedRate);
            setIsTaskCountLoading(false);
        }
        catch(err)
        {
            console.log(err);
        }
    }

    const getMembersAchievementRate = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                setIsMembersAchievementRateEnd(true);
                return;
            }
           
            const jsonData = res['data']['ranking'];
    
            for(let i = 0; i < jsonData.length; ++i)
            {
                if(taskCount !== null && taskCount['result_count'] === jsonData[i]['result_count'] && isMember === true)
                {
                    jsonData[i]['nickname'] = userInfo['name'];
                    jsonData[i]['user_no'] = userInfo['id'];
                    jsonData[i]['profile_img'] = userInfo['profile_img'];
                }
                jsonData[i]['rate'] = Math.floor((jsonData[i]['result_count'] / jsonData[i]['task_count']) * 100)
            }
            
            setMemberAchievementRateList(jsonData);
            setIsMembersAchievementRateLoading(false);
        }
        catch(err)
        {
            console.log(err);
        }
    }

    const handleClickCalendar = () => {
        history.push('/calendar');
    }

    useEffect(() => {
        if(taskCount !== null)
        {
            if(isMembersAchievementRateLoading || isMembersAchievementRateEnd) return;
            setIsMembersAchievementRateLoading(true);
            server.getRequestData(`campaigns/${campaignNo}/achivement/ranking`, getMembersAchievementRate );
        }
    }, [taskCount])

    useEffect(async () => {
        if(!isTaskCountLoading || !isTaskCountEnd)
        {
            if(userInfo['isLogin'])
            {
                setIsTaskCountLoading(true);
                await server.getRequestData(`campaigns/${campaignNo}/members/${userInfo['id']}/achievement`, getTaskCount);
            }
        }
        
        if(!isMembersAchievementRateLoading || !isMembersAchievementRateEnd)
        {
            if(isMember === false || userInfo['isLogin'] === false)
            {
                setIsMembersAchievementRateLoading(true);
                server.getRequestData(`campaigns/${campaignNo}/achivement/ranking`, getMembersAchievementRate );
            }
        };
        return;
    }, [])

    useEffect(()=>{
        server.getRequestData(`campaigns/${campaignNo}/members/tasks/results?get_total_user=true&task_date=${formatDate()}`, (res)=>{
            try
            {
                if(res['success'] !== 1)
                { 
                    const errData = res['error'];

                    if(errData?.detail_code === 'LOGIN_REQ')
                    {
                        
                    }
                    else
                    {

                    }
                    return ;
                }
                const jsonData = res['data']; 
                const activeMemberNum = jsonData['count']
                
                if(campaignInfo['start_date'] > formatDate())
                {
                    setTopNoteText(`두근두근💗 이제 곧 챌린지가 시작됩니다`)
                }
                else if(campaignInfo['end_date'] < formatDate())
                {
                    setTopNoteText(`다른 챌린지도 도전해 보세요!`)
                }
                else if(activeMemberNum && activeMemberNum > 0)
                {
                    setTopNoteText(`오늘 ${activeMemberNum}명이 함께 달리고 있어요!`)
                }
                else
                {
                    setTopNoteText(`오늘의 첫번째 러너가 되어보세요`)
                }
            }
            catch(err)
            {
                console.log(err);
            }
        })
        
    },[])
    
    const lottieOptions={
        loop: true,
        autoplay: true,
        renderer: 'svg',
        animationData: LoadingAnimation
    }
    return (
        <>
        { isTaskCountLoading || isMembersAchievementRateLoading? (
            <LoadingAnimationWrapper>
                <LottieLodder lottieOptions={lottieOptions} style={{width: 'calc(100vw * (40 / 375))'}}/>
            </LoadingAnimationWrapper>
        ) : (
            <SectionWrapper>
                <NoteWrapper>
                    <CurrentActiveUserNote  noteText={topNoteText}/>
                </NoteWrapper>
                <AchievementRateWrapper>
                    {isMember ? (
                        <MyAchievementRate 
                            userInfo={userInfo} 
                            taskCount={taskCount} 
                            completeRate={completeRate}
                            handleClickCalendar={handleClickCalendar}
                        />
                    ) : null}
                    <AchievementRateList userInfo={userInfo} memberAchievementRateList={memberAchievementRateList}/>
                </AchievementRateWrapper>
            </SectionWrapper>
            )
        }
        </>
    );
}

const SectionWrapper = styled.div` 
    background-color: #f7f7f7;
    height: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
`; 
const NoteWrapper = styled.div`
    flex: 0 1 auto;
`;
const AchievementRateWrapper = styled.div`
    padding: calc(100vw * (17 /375)) calc(100vw * (17 /375)) 0 calc(100vw * (17 /375));
    height: 100%;
    flex: 1 1 auto;
`;

const LoadingAnimationWrapper = styled.div`
    display: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-itens: center;
    width: 100%;
    height: 100%;
`;